// extracted by mini-css-extract-plugin
module.exports = {"animateUp":"styles_animateUp__BNXr1","slideUp":"styles_slideUp__evism","animateDown":"styles_animateDown__gCG7T","slideDown":"styles_slideDown__nqHzt"};